<template>
  <div class="min-h-screen">
    <Header />

    <!-- Hero Section -->
    <section class="page-hero-shell pt-32 pb-20">
      <div class="hero-orb page-overlay-layer hero-orb-a"></div>
      <div class="hero-orb page-overlay-layer hero-orb-b"></div>

      <div class="page-content-layer max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
          <h1 class="text-5xl md:text-7xl font-bold mb-6">
            <span class="gradient-text">不涉及用户隐私数据声明</span>
          </h1>
          <p class="text-xl text-gray-700 dark:text-dark-muted max-w-3xl mx-auto">
            我们致力于为用户提供优质、安全、可靠的数字化服务
          </p>
        </div>
      </div>
    </section>

    <!-- Content -->
    <section class="py-20">
      <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="card p-8 md:p-12 space-y-8 text-gray-700 dark:text-dark-muted">
          <p><strong>尊敬的用户，您好！</strong></p>
          <p>感谢您使用本公司提供的服务。我们致力于为用户提供优质、安全、可靠的数字化服务，包括但不限于快应用、小程序及官方网站。为此，我们郑重声明：</p>

          <div>
            <h2 class="text-2xl font-bold text-gray-900 dark:text-dark-text mb-3">关于隐私数据的承诺</h2>
            <p>在您使用我们提供的服务时，我们承诺仅收集cookie等不指向个人隐私的匿名数据，不会存储、处理或共享任何形式的用户个人隐私数据，包括但不限于：</p>
            <ul class="list-disc list-inside space-y-1 mt-3 ml-2">
              <li>姓名、身份证号、联系方式；</li>
              <li>位置信息、设备信息；</li>
              <li>支付信息及其他可能涉及隐私的数据。</li>
            </ul>
          </div>

          <div>
            <h2 class="text-2xl font-bold text-gray-900 dark:text-dark-text mb-3">数据使用及服务特性</h2>
            <div class="space-y-3">
              <p>1. <strong>本地化处理</strong>：无论是快应用还是小程序，您的所有操作均在本地设备完成，不涉及任何形式的远程数据传输或存储。</p>
              <p>2. <strong>安全性</strong>：公司官网仅提供公开信息展示与访问功能，不会请求或收集用户的个人信息。</p>
              <p>3. <strong>隐私友好</strong>：我们的服务设计原则是"隐私最小化"，在功能实现中，完全不依赖用户的隐私数据。</p>
            </div>
          </div>

          <div>
            <h2 class="text-2xl font-bold text-gray-900 dark:text-dark-text mb-3">合规与透明性</h2>
            <p>我们严格遵守相关法律法规要求，包括但不限于《中华人民共和国个人信息保护法》、《数据安全法》等。尽管我们的服务不涉及用户隐私数据，但仍坚持以最高标准维护用户的知情权和使用体验。</p>
          </div>

          <div>
            <h2 class="text-2xl font-bold text-gray-900 dark:text-dark-text mb-3">联系我们</h2>
            <p>若您有任何疑问或需进一步了解，请通过以下方式与我们联系：</p>
            <div class="mt-3 space-y-1">
              <p><strong>我们是：</strong>上海咩叽科网络</p>
              <p><strong>官方网站：</strong>https://magicacid.cn/about</p>
              <p><strong>联系邮箱：</strong>kenny9@magicacid.cn</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
useHead({
  title: '隐私协议 - MAGIC',
  meta: [
    { name: 'description', content: 'MAGIC 隐私政策 - 不涉及用户隐私数据声明' }
  ]
})
</script>
